export const environment = {
  production: true,
  firebase:{
     apiKey: "AIzaSyA0zL0HbTSDL1_esOxHvvIk1rh_ssS-yfE",
  authDomain: "philippine-history-timelines.firebaseapp.com",
  databaseURL: "https://philippine-history-timelines-default-rtdb.firebaseio.com",
  projectId: "philippine-history-timelines",
  storageBucket: "philippine-history-timelines.appspot.com",
  messagingSenderId: "661351369986",
  appId: "1:661351369986:web:e6af5f051109ea71e8061b",
  measurementId: "G-XM31L59TM8"
  }
};
